/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。   
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormPagePropertyItemSingleSelectionErrorMessage } from './formPagePropertyItemSingleSelectionErrorMessage';
import { FormPagePropertyItemSingleSelectionPropertyItem } from './formPagePropertyItemSingleSelectionPropertyItem';
import { FormPagePropertyItemSingleSelectionDrillDownSetting } from './formPagePropertyItemSingleSelectionDrillDownSetting';
import { FormPagePropertyItemSingleSelectionInputFormat } from './formPagePropertyItemSingleSelectionInputFormat';
import { FormPagePropertyItemSingleSelectionCandidate } from './formPagePropertyItemSingleSelectionCandidate';
import { FormPagePropertyItemSelectionRequiredSubtext } from './formPagePropertyItemSelectionRequiredSubtext';
import { FormPagePropertyItemSelectionRegistrationLimitSetting } from './formPagePropertyItemSelectionRegistrationLimitSetting';
import { FormPagePropertyItemStringConvertRule } from './formPagePropertyItemStringConvertRule';


/**
 * 単一選択型の入力項目を表す。 
 */
export interface FormPagePropertyItemSingleSelection { 
    /**
    * フォーム入力項目大種別
    */
    propertyType: 'singleSelection';
    /**
    * 入力項目ID
    */
    propertyId: string;
    /**
    * 項目名(管理機能のopenapiではdisplay_name）
    */
    name: string;
    /**
    * 項目のコメント(管理機能のopenapiではdisplay_comment）
    */
    comment?: string;
    /**
    * 注意書き・凡例(管理機能のopenapiではcaution）
    */
    note?: string;
    /**
    * 必須/任意のラベルを表示するかどうか.
    */
    displayRequiredLabel: boolean;
    stringConvertRule?: FormPagePropertyItemStringConvertRule;
    type: FormPagePropertyItemSingleSelection.TypeEnum;
    properties: FormPagePropertyItemSingleSelectionPropertyItem;
    inputFormat: FormPagePropertyItemSingleSelectionInputFormat;
    candidates: Array<FormPagePropertyItemSingleSelectionCandidate>;
    errorMessage?: FormPagePropertyItemSingleSelectionErrorMessage;
    /**
    * 補助テキストが必須となる選択肢と、選択肢ごとのエラーメッセージの配列. 補助テキストの必須判定に利用
    */
    requiredSubtext?: Array<FormPagePropertyItemSelectionRequiredSubtext>;
    drillDown?: FormPagePropertyItemSingleSelectionDrillDownSetting;
    registrationLimit?: FormPagePropertyItemSelectionRegistrationLimitSetting;
    /**
    * この単一選択型が必須の場合に、固定値 value が入る
    */
    required?: Array<string>;
}

export namespace FormPagePropertyItemSingleSelection {
    export type TypeEnum = 'object';
    export const TypeEnum = {
        Object: 'object' as TypeEnum
    };
}


